import { aplicarMascara } from "@/utils/MaskUtils.js";
import { isBlank } from "@/utils/StringUtils.js";


export const MASCARA_CPF = "###.###.###-##";

export const formatarCpf = (cpf) => {
	if(isBlank(cpf)){
		return "";
	}
	return aplicarMascara(cpf,MASCARA_CPF);
};
